export class RefreshTokenError extends Error {}
